import { render, staticRenderFns } from "./TypeMissWord.vue?vue&type=template&id=4fe33908"
import script from "./TypeMissWord.vue?vue&type=script&lang=js"
export * from "./TypeMissWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports